<template>
  <div class="page">
    <Header></Header>
    <div class="body">
        <div class="intro">
          管培生项目是汽车之家的重要项目之一，旨在培养未来核心管理人才，培育“价值观优，忠诚度高，胜任力强，业务性专”的长期中坚力量。
        </div>
        <div style="height: 1px;width: 100%;"></div>
        <div class="box">
          <img :src="require('@/assets/ziyuan.png')" class="box-icon" />
          <div class="box-title">顶尖资源</div>
          <div class="box-text">
            之家对管培生项目配置了最顶尖资源，包括高管亲自带教指导、核心关键岗位轮岗、创新挑战项目、全球技术交流等，加速激发你的全局视野和思维能力。
          </div>
        </div>
        <div style="height: 1px;width: 100%;"></div>
        <div class="box">
          <img :src="require('@/assets/jihua.png')" class="box-icon" />
          <div class="box-title">顶流计划</div>
          <div class="box-text">
            在每个发展阶段中，之家会提供从前沿技术、商业思维，到行业全览、管理技能等全方位的培训内容，一步步实现从校园人、职场人、之家人、领军人的全周期发展蓝图。
          </div>
        </div>
      <div style="height: 1px;width: 100%;"></div>
      <div class="box">
        <img :src="require('@/assets/fuchi.png')" class="box-icon" />
        <div class="box-title">顶级扶持</div>
        <div class="box-text">
          除了带教辅导、素拓、分享等形式外，我们还为管培生配备了专属团队进行全程扶持，关注你的每一步成长。加速赋能发展、加速激励晋级，更快实现自我成就。
        </div>
      </div>
      <SafeBottom></SafeBottom>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header1";
import Footer from "./Footer";
import SafeBottom from "./SafeBottom";
import Utils from "../utils/Utils";

export default {
  name: "Intro",
  components:{
    SafeBottom,
    Header,
    Footer
  },
  data(){
    return {
      app:"",
    }
  },
  mounted: function() {
    this.app = Utils.getApp();
  }
}
</script>

<style scoped>
  .page{
    background-color: #F8F9FC;
    height: 100%;
    flex-direction: column;
    display: flex;
  }
  .body{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #222222;
    font-weight: 400;
    padding: 20px;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .intro{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #222222;
    font-weight: 400;
    text-indent:2em;
    margin-bottom: 20px;
  }
  .box{
    background-color: #FFFFFF;
    border-radius: 12px;
    padding: 16px;
    margin: 20px 0;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .box-icon{
    width: 40px;
    height: 40px;
    top:-20px;
    position: absolute;
  }
  .box-title{
    margin: 16px 0;
    font-family: PingFangSC-Semibold;
    font-size: 22px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;
  }
  .box-text{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666D7F;
    font-weight: 400;
    text-align: left;
  }

</style>